import React, { useRef } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../styles/Contact/conatct.css";
import CountrySelect from "../../Components/enroll/CountrySelect"; // Adjust path if needed

const ContactSection = () => {
  const formRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault(); // stop redirect

    const formData = new FormData(formRef.current);

    // Optional identifier
    formData.append("FormType", "Madhi Academy Indian Professional Courses");

    try {
      const response = await fetch(
        "https://formsubmit.co/ajax/admission@madhiacademy.com",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: formData,
        }
      );

      if (response.ok) {
        alert("Thank you! Your details have been submitted successfully.");
        formRef.current.reset(); // clear form
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      alert("Network error. Please try again later.");
    }
  };

  return (
    <section className="contact-form-section py-5">
      <div className="container">
        <div className="row g-5 justify-content-between">
          {/* LEFT COLUMN: Contact Form */}
          <div className="col-lg-7 col-md-12">
            <form
              ref={formRef}
              onSubmit={handleSubmit}
              className="contact-form-wrapper"
            >
              <div className="row g-4">
                {/* First Name & Last Name */}
                <div className="col-md-6">
                  <label className="contact-form-label">
                    First Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="Firstname"
                    className="form-control contact-custom-input"
                    placeholder="Enter First Name"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="contact-form-label">Last Name</label>
                  <input
                    type="text"
                    name="Lastname"
                    className="form-control contact-custom-input"
                    placeholder="Enter Last Name"
                  />
                </div>

                {/* Gender & DOB */}
                <div className="col-md-6">
                  <label className="contact-form-label">
                    Gender <span className="text-danger">*</span>
                  </label>
                  <select
                    name="Gender"
                    className="form-select contact-custom-input text-muted"
                    defaultValue=""
                  >
                    <option value="" disabled>
                      Select Gender
                    </option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="contact-form-label">
                    Date of Birth <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    name="Date of Birth"
                    className="form-control contact-custom-input text-muted"
                    required
                  />
                </div>

                {/* Email */}
                <div className="col-md-6">
                  <label className="contact-form-label">
                    Email ID <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    name="Email"
                    className="form-control contact-custom-input"
                    placeholder="Enter Your Mail ID"
                    required
                  />
                </div>

                {/* Mobile Number with Country Select - THE FIX */}
                <div className="col-md-6">
                  <label className="contact-form-label">
                    Mobile Number <span className="text-danger">*</span>
                  </label>

                  {/* Added 'flex-nowrap' to ensure they stay on one line */}
                  <div className="input-group flex-nowrap">
                    <div className="contact-country-select-wrapper">
                      <CountrySelect
                        onChange={(code) =>
                          formRef.current?.append("country_code", code)
                        }
                      />
                    </div>

                    <input
                      type="tel"
                      name="Mobile Number"
                      className="form-control contact-custom-input border-start-0 ps-3 w-100"
                      placeholder="Enter Your Mobile Number"
                      required
                    />
                  </div>
                </div>

                {/* Message */}
                <div className="col-12">
                  <label className="contact-form-label">
                    Describe your need <span className="text-danger">*</span>
                  </label>
                  <textarea
                    name="Message"
                    className="form-control contact-custom-input"
                    rows="4"
                    placeholder="Type your message here..."
                    required
                  ></textarea>
                </div>
                {/* Hidden FormSubmit Settings */}
                <input
                  type="hidden"
                  name="_subject"
                  value="Madhi Academy Indian Professional Courses"
                />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_template" value="table" />

                {/* Submit Button */}
                <div className="col-md-5 mt-4">
                  <button
                    type="submit"
                    className="btn contact-btn-purple w-100 py-2 fw-semibold"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>

          {/* RIGHT COLUMN: Connect Info Box */}
          <div className="col-lg-5 col-md-12">
            <h4 className="fw-bold mb-4 text-dark">Connect with us</h4>

            <div className="contact-info-card p-4 rounded-4">
              {/* Phone */}
              <div className="d-flex align-items-center mb-4">
                <div className="contact-icon-box flex-shrink-0 me-3">
                  <i className="bi bi-telephone-fill text-white fs-5"></i>
                </div>
                <div>
                  <div className="contact-text-purple small fw-bold mb-1">
                    Our Phone
                  </div>
                  <div className="fw-bold text-dark">+91 77089 41960</div>
                </div>
              </div>

              {/* Email */}
              <div className="d-flex align-items-center mb-4">
                <div className="contact-icon-box flex-shrink-0 me-3">
                  <i className="bi bi-envelope-fill text-white fs-5"></i>
                </div>
                <div>
                  <div className="contact-text-purple small fw-bold mb-1">
                    Our Email
                  </div>
                  <div
                    className="fw-bold text-dark text-break"
                    style={{ fontSize: "0.95rem" }}
                  >
                    admission@madhiacademy.com
                  </div>
                </div>
              </div>

              {/* Location */}
              <div className="d-flex align-items-start">
                <div className="contact-icon-box flex-shrink-0 me-3">
                  <i className="bi bi-map-fill text-white fs-5"></i>
                </div>
                <div>
                  <div className="contact-text-purple small fw-bold mb-1">
                    Our Location
                  </div>
                  <div className="fw-bold text-dark lh-sm">
                    Madhi Academy – Global Courses Division,
                    <br />
                    Nammalwarpet, Chennai – India
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MAP SECTION */}
        <div className="row mt-5">
          <div className="col-12">
            <div className="contact-map-wrapper shadow-sm">
              <iframe
                title="Madhi Academy Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.279678456789!2d80.245678!3d13.089678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTPCsDA1JzIyLjgiTiA4MMKwMTQnNDQuNCJF!5e0!3m2!1sen!2sin!4v1634567890123!5m2!1sen!2sin"
                width="100%"
                height="350"
                style={{ border: 0, display: "block" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
